// RechercheIntelContext.jsx

import React, { createContext, useState } from 'react';

const RechercheIntelContext = createContext();

export const RechercheIntelProvider = ({ children }) => {
  // === Filtres ===
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedPlayerType, setSelectedPlayerType] = useState('all');

  // === Ouverture des lignes (Collapses) ===
  const [openRows, setOpenRows] = useState({});

  // Toggle d'une ligne (ouvre/ferme la collapse)
  const toggleRow = (rowId) => {
    setOpenRows((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  return (
    <RechercheIntelContext.Provider
      value={{
        // Filtres
        selectedPlayer,
        setSelectedPlayer,
        selectedUser,
        setSelectedUser,
        selectedPlayerType,
        setSelectedPlayerType,

        // openRows
        openRows,
        setOpenRows,
        toggleRow,
      }}
    >
      {children}
    </RechercheIntelContext.Provider>
  );
};

export default RechercheIntelContext;
